import { useDisplayContext } from '~src/context/DisplayContext';
import { ProductType } from '~src/model';

export const useCarouselBreakPoints = () => {
  const { width } = useDisplayContext();

  if (width >= 2350) {
    return 5;
  }
  if (width >= 2000) {
    return 4;
  }
  if (width >= 1550) {
    return 3;
  }
  if (width >= 1200) {
    return 2;
  }
  return 1;
};

export const getNoProductsMessage = (productType: ProductType) =>
  `Vi har ikke nok data til at foreslå produkter til ${
    productType === 'heatPump' ? 'en varmepumpe' : 'et solcelleanlæg'
  } produkt. Gennemfør de foregående trin for at se produktforslag.`;
